var log = Math.log;
var LOG10E = Math.LOG10E; // eslint-disable-next-line es-x/no-math-log10 -- safe

module.exports = Math.log10 || function log10(x) {
  return log(x) * LOG10E;
};